var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginEmbelishment2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 616.655,
    height: 427.817,
    viewBox: "0 0 616.655 427.817",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lclr4r6jma",
    x1: 0.419,
    y1: 0.694,
    x2: 0.486,
    y2: 0.19,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edeff7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Background embelishment_2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Intersection 51",
    d: "M0 427.816 370.973 25.275C388.542 6.211 425.454-4.342 453.418 1.7L616.655 37v390.82z",
    style: {
      fill: "url(#lclr4r6jma)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Intersection 57",
    d: "M84.988 20.607 0 112.829h236.269V19.564L152.208 1.39A65.05 65.05 0 0 0 138.5 0c-20.013 0-41.924 8.034-53.512 20.607z",
    transform: "translate(380.386 314.988)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginEmbelishment2);
export default __webpack_public_path__ + "static/media/login-embelishment-2.e874b165924e295f1420f646c38d2a5f.svg";
export { ForwardRef as ReactComponent };